import React from "react";
import PropTypes from "prop-types";
import { Component } from "react";
import HelperContent from "../../helperContent/HelperContent";
import QuestionLabel from "../../question/QuestionLabel";
import QuestionOption from "../../question/QuestionOption";
import Footer from "../../Footer";
import cookieHelper from "../../../helpers/cookies";
import { has } from "lodash";

class CodeWordValidator extends Component {
    render() {
        let question = this.props.question;
        let store = this.props.store;
        let className = "w3-panel w3-opacity" + (has(question, "class") ? " " + question.class : " w3-large w3-center");

        let options = question.options;
        let optionsCode = null;
    
        if (options && options.length > 0) {
            optionsCode = (
                <ul className="w3-ul w3-border w3-padding-small w3-margin-top">
                    {options.map(option => (
                        <li className="question-option w3-xlarge w3-center" key={option.itemID}>
                            <QuestionOption option={option} onClick={() => this.props.selectionMade(option)} />
                        </li>
                    ))}
                </ul>
            );
        }

        cookieHelper.removeCookie(store.getState().referenceId); // remove the referenceId cookie so that the workflow does not try to resume next time from the completion page
        let codeWord = localStorage.getItem("attestivCodeWordPhrase");
        if (!codeWord) {
            return (
                <div className="form w3-header w3-animate-opacity">
                    <div id={question.questionID} className={className} dangerouslySetInnerHTML={{__html: "This device is not authorized for this transaction. Please contact your closing agent."}}></div>
                    <Footer question={question}/>
                </div>
            )
        }

        return (
            <div className="form w3-header w3-animate-opacity">
                <QuestionLabel question={question} store={store}/>
                <HelperContent question={question} />
                <div id={question.questionID} className={className} dangerouslySetInnerHTML={{__html: codeWord}}></div>
                <div className="question-options">{optionsCode}</div>
                <Footer question={question}/>
            </div>
        )
    }
};

CodeWordValidator.propTypes = {
    question: PropTypes.object,
    store: PropTypes.object
};

export default CodeWordValidator;
